import { motion } from "framer-motion";
import { FileText, AlertTriangle } from "lucide-react";
import { Progress } from "@/components/ui/progress";
import { Button } from "@/components/ui/button";
import { Skel } from "@/components/app/Common";

export function ParseProgress({ filename, progress, message, failed, reason, onRetry }) {
  if (failed) {
    return (
      <div className="space-y-4 rounded-[6px] border border-[#E8C9C5] bg-risk-tint/60 p-5" data-testid="single-parse-failed" role="alert">
        <p className="flex items-center gap-2 text-sm font-medium text-risk"><AlertTriangle size={16} aria-hidden="true" /> We couldn't read {filename}</p>
        <p className="text-sm text-ink-secondary" data-testid="single-parse-failed-reason">{reason}</p>
        <Button variant="outline" onClick={onRetry} data-testid="single-parse-retry">Try another file</Button>
      </div>
    );
  }
  return (
    <motion.div initial={{ opacity: 0, y: 6 }} animate={{ opacity: 1, y: 0 }} className="space-y-5" data-testid="single-parse-progress" aria-busy="true">
      <div className="flex items-center gap-3 rounded-[6px] border border-line bg-white p-4">
        <FileText size={18} className="text-brand" aria-hidden="true" />
        <div className="min-w-0 flex-1">
          <p className="truncate text-sm font-medium text-ink">{filename}</p>
          <p className="text-xs text-ink-secondary" data-testid="single-parse-message" aria-live="polite">{message || "Queued"}</p>
        </div>
        <span className="text-xs tabular-nums text-ink-muted">{Math.round(progress || 5)}%</span>
      </div>
      <Progress value={progress || 5} className="h-1.5 bg-brand-tint" data-testid="single-parse-bar" />
      <div className="grid gap-4 sm:grid-cols-2">{Array.from({ length: 6 }).map((_, i) => <div key={i} className="space-y-1.5"><Skel className="h-3 w-24" /><Skel className="h-9 w-full" /></div>)}</div>
      <Skel className="h-20 w-full" />
    </motion.div>
  );
}
